
const getSession = () => {
  return JSON.parse(localStorage.getItem('__session__') || '{}');
};

const body = (userId, apiToken, expireDateTime, role, constructionId?) => {
  return {
    "tenantId": {
      "content": "1"
    },
    "userId": {
      "content": userId
    },
    "apiToken": {
      "content": apiToken
    },
    "expireDateTime": {
      "content": expireDateTime
    },
    "role": {
      "content": role
    },
    "residentAccessUrl": {
      "content": constructionId ? { content: constructionId } : undefined
    }

  };
}

export const RoomList = () => {
  const { userId, role, apiToken, apiTokenExpired: expireDateTime } = getSession();
  const { id: constructionId } = JSON.parse(localStorage.getItem('_data') || '{}');
  const params = body(userId, apiToken, expireDateTime, role, constructionId);
  return {
    "mode": 'MODE_READ_CONSTRUCTION_ROOMS',
    "param": {
      ...params,
    }
  }
}

export const Options = () => {
  const { userId, role, apiToken, apiTokenExpired: expireDateTime } = getSession();
  const { id: constructionId } = JSON.parse(localStorage.getItem('_data') || '{}');
  const params = body(userId, apiToken, expireDateTime, role, constructionId);

  return {
    "mode": "MODE_READ_WORK_OPTION",
    "param": {
      ...params,
    }
  }
}

export const SaveBookingData = (bookingData) => {
  const { userId, role, apiToken, apiTokenExpired: expireDateTime } = getSession();
  const { id: constructionId } = JSON.parse(localStorage.getItem('_data') || '{}');
  const params = body(userId, apiToken, expireDateTime, role, constructionId);
  const lockVersion = localStorage.getItem('lockVersion');

  return {
    "mode": "MODE_CREATE_REGISTER_BOOKING",
    "param": {
      ...params,
      "data": { "content": bookingData },
      "lockVersion": { "content": lockVersion }
    }
  }
}

export const UpdateBookingData = (updateData) => {
  // const { userId, apiToken, expireDateTime, role } = await createToken();
  // const { id: constructionId } = JSON.parse(localStorage.getItem('_data') || '{}');
  // const params = body(userId, apiToken, expireDateTime, role, constructionId);
  const { userId, role, apiToken, apiTokenExpired: expireDateTime } = getSession();
  const { id: constructionId } = JSON.parse(localStorage.getItem('_data') || '{}');
  const params = body(userId, apiToken, expireDateTime, role, constructionId);
  return {
    "mode": "MODE_UPDATE_REGISTERED_BOOKING",
    "param": {
      ...params,
      ...updateData
    }
  }
}

export const DataCalendar = () => {
  const { userId, role, apiToken, apiTokenExpired: expireDateTime } = getSession();
  const { id: constructionId } = JSON.parse(localStorage.getItem('_data') || '{}');

  const dataRegisterRoom: any = localStorage.getItem('_dataRegisterRoom') || {};
  const parseData = JSON.parse(dataRegisterRoom);
  const roomId = parseData.room;
  const params = body(userId, apiToken, expireDateTime, role, constructionId);

  return {
    "mode": "MODE_READ_RESERVATION_TIME_SLOT",
    "param": {
      ...params,
      "roomId": {
        "content": roomId
      }
    }
  }
}

export const DataRebook = () => {
  const { userId, role, apiToken, apiTokenExpired: expireDateTime } = getSession();
  const { id: constructionId } = JSON.parse(localStorage.getItem('_data') || '{}');
  const bookingNumber = localStorage.getItem('_bookingNumber');
  const params = body(userId, apiToken, expireDateTime, role, constructionId);
  return {
    "mode": "MODE_READ_REGISTERED_BOOKING",

    "param": {
      ...params,
      "reservationNumber": {
        "content": bookingNumber
      },
    }
  }
}

export const DownLoadInstruction = (payload) => {
  const { anonymousToken, expireDateTime, uuid, bookingSiteUrl } = payload;

  return {
    "mode": "MODE_DOWNLOAD_CONSTRUCTION_INSTRUCTIONS",
    "param": {
      "tenantId": {
        "content": "1"
      },
      "uuid": {
        "content": uuid
      },
      "anonymousToken": {
        "content": anonymousToken
      },
      "expireDateTime": {
        "content": expireDateTime
      },
      "residentAccessUrl": {
        "content": bookingSiteUrl
      }
    }
  }
}

export const DataHomeScreen = (payload) => {
  const { anonymousToken, expireDateTime, uuid, bookingSiteUrl } = payload
  return {
    "mode": "MODE_READ_CONSTRUCTION_INFO",
    param: {
      tenantId: {
        content: "1"
      },
      "uuid": {
        "content": uuid
      },
      "anonymousToken": {
        "content": anonymousToken
      },
      "expireDateTime": {
        "content": expireDateTime
      },
      "residentAccessUrl": {
        "content": bookingSiteUrl
      }
    }
  }
};
